import { toastError } from "../redux/guest-slices/other.slice"
import { jwtDecode } from "jwt-decode"
import { Cookies } from "react-cookie"
import moment from "moment-timezone";

const cookies = new Cookies()
const adminTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone

// export const BASEURI = "http://localhost:8000/v1/api"
// export const SOCKET_BASEURI = "http://localhost:8001"
// export const FILE_PATH_URI = "http://localhost:8000/src/uploads/"

export const BASEURI = process.env.REACT_APP_BASEURI || "http://localhost:5000/v1/api"
export const FILE_PATH_URI = process.env.REACT_APP_FILE_PATH_URI || "http://localhost:5000/src/uploads/"
export const SOCKET_BASEURI = process.env.REACT_APP_SOCKET_BASEURI || "http://localhost:5001"

export const checkTokenErr = (err, dispatch) => {
  if (err.response.data.redirect) {
    cookies.remove("token", { path: "/" })
    dispatch({ type: "Logout", payload: "" })
    window.location.replace(err.response.data?.location)
  }
}

export const checkToken = (dispatch) => {
  const token = cookies.get("token")
  try {
    if (token) {
      const decodedToken = jwtDecode(token)
      if (decodedToken?.exp * 1000 > Date.now()) {
        return true
      } else {
        cookies.remove("token", { path: "/" })
        dispatch({ type: "Logout", payload: "" })
        dispatch(toastError("Token expired. Please login again!"))
        return false
      }
    } else {
      return false
    }
  } catch (error) {
    const errorMessage = error?.message?.split(":")[0]
    dispatch(toastError(errorMessage))
  }
}

export const headers = () => {
  return {
    "withCredentials": true,
    "credentials": "include",
    "Content-Type": "application/json",
    "Authorization": `Bearer ${cookies.get("token")}`,
  }
}

export const handleDownload = async (doc) => {
  try {
    const response = await fetch(doc?.fileURL || doc);
    const blob = await response.blob();
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = doc?.fileName || "downloaded-file";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Download failed", error);
  }
}

export const debounce = (func, delay = 500) => {
  let timeoutId
  return (...args) => {
    clearTimeout(timeoutId)
    timeoutId = setTimeout(() => func(...args), delay)
  }
}


export const formatTime = (utc) => moment(utc).tz(adminTimezone).format("h:mm A")
export const formatDate = (utc) => moment(utc).tz(adminTimezone).format("DD MMM YYYY")